import Modal from './Modal/Modal';

const ModalFrame = ({
	open,
	onClose,
	src,
}: {
	open: boolean;
	onClose: () => void;
	src: string;
}) => {
	return (
		<Modal
			open={open}
			onClose={onClose}
			sx='!p-2'
		>
			<div className='!w-[90vw] max-w-[800px] h-[calc(100vh-100px)] pt-6 relative rounded-lg overflow-hidden'>
				<iframe
					title='Embedded Page'
					width='100%'
					height='100%'
					src={src}
					allowFullScreen
				></iframe>
			</div>
		</Modal>
	);
};

export default ModalFrame;
